import React from 'react';
import './OrdersFilter.scss';
import { DatePicker } from './DatePicker';
import { Input } from './Input';
import { isToday } from '../../../utils/date';
import { searchOrders } from '../../../businessLogic/onDemandOrdersFilter';
import { gettext } from '../../../i18n/service';

export class OrdersFilterComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            toggle: true
        };
        this.clickSearch = this.clickSearch.bind(this);
    }

    onDateChange(date) {
        this.props.actions.setFilterDate(date);
        this.props.actions.getOrdersForDate(this.props.companyId, date);
    }

    onSearchChange(text) {
        this.props.actions.setFilterSearch(text);
    }

    onSearchEnter() {
        const text = this.props.state.search;
        if (!text || !text.trim().length) return;

        this.props.actions.setFilterSearchEntered();
        const { newOrders, inProgress, history} = searchOrders(this.props.orders, text);
        if (newOrders.length) return this.props.actions.expandNewOrders();
        if (inProgress.length) return this.props.actions.expandInProgressOrders();
        if (history.length) return this.props.actions.expandHistoryOrders();
    }

    clickSearch() {
        this.setState({toggle: !this.state.toggle});
        if(this.state.toggle)
            this.clearFilter();
        else
            this.props.actions.toggleFilterSearch();
    }

    showSearchClear(state) {
        return !isToday(state.date) || state.search && state.search.trim().length;
    }

    clearFilter() {
        const reloadOrders = !isToday(this.props.state.date);
        this.props.actions.clearFilter();
        if (reloadOrders) {
            this.props.actions.getTodayOrders(this.props.companyId);
        }
    }

    renderSearch(state) {
        if (state.searchOpen) {
            return (<Input type="text" className="search"
                onChange={text => this.onSearchChange(text)} onEnterPressed={text => this.onSearchEnter()}
                value={state.search} />);
        }

        return (
            <div className="custom-datepicker">
                <DatePicker date={state.date} onChange={date => this.onDateChange(date)} orientation="right"/>
            </div>
        );
    }

    renderSearchClear(state) {
        if (!this.showSearchClear(state)) {
            return false;
        }

        return (
            <button type="button" className="close clear" aria-label="Close" onClick={() => this.clearFilter()}>
                <span aria-hidden="true">&times;</span>
            </button>
        );
    }

    render() {
        const state = this.props.state;
        return (
            <div className="orders-filter">
                <span>{gettext('ORDERS')}</span>
                &nbsp;
                {this.renderSearch(state)}
                &nbsp;
                <img src="./side_search.svg" className="search-icon" onClick={() => this.clickSearch()} />
                {this.renderSearchClear(state)}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/sidebarOrders/ordersFilter/OrdersFilterComponent.js